import { c as _c } from "react/compiler-runtime";
import React, { useContext, useState } from "react";
import styles from "./DKGavebrevTaxWidget.module.scss";
import { DKGavebrevTaxBarChart } from "./DKGavebrevTaxBarChart";
import { EffektButton, EffektButtonVariant } from "../../../shared/components/EffektButton/EffektButton";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { WidgetContext } from "../../layout/layout";
import { HorizontalDKGavebrevTaxBarChart } from "./DKGavebrevTaxBarChartHorizontal";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { usePlausible } from "next-plausible";
import { thousandize } from "../../../../util/formatting";
export const DKGavebrevTaxWidget: React.FC<{
  title: string;
  description: string;
  incomeLabel?: string;
  donationLabel?: string;
  defaultIncome: number;
  defaultDonation: number;
  resultDescriptionTemplate?: string;
  buttonText?: string;
  chartLabels?: {
    maximumDeduction?: string;
    yourDonation?: string;
    yourTaxBenefit?: string;
  };
  locale: string;
}> = t0 => {
  const $ = _c(61);
  const {
    title,
    description,
    incomeLabel,
    donationLabel,
    defaultIncome,
    defaultDonation,
    resultDescriptionTemplate,
    buttonText,
    chartLabels,
    locale
  } = t0;
  const plausible = usePlausible();
  let t1;
  if ($[0] !== defaultIncome || $[1] !== locale) {
    t1 = () => formatAmountInput(defaultIncome.toString(), locale);
    $[0] = defaultIncome;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [income, setIncome] = useState(t1);
  let t2;
  if ($[3] !== defaultDonation || $[4] !== locale) {
    t2 = () => formatAmountInput(defaultDonation.toString(), locale);
    $[3] = defaultDonation;
    $[4] = locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [donation, setDonation] = useState(t2);
  const lastValidIncome = parseAmountInput(income);
  const lastValidDonation = parseAmountInput(donation);
  const [widgetContext, setWidgetContext] = useContext(WidgetContext);
  const isMobile = useIsMobile();
  const suggestedPercentages = [0.01, 0.05, 0.1];
  const maximumDeduction = lastValidIncome * 0.92 * 0.15;
  const effectiveDonation = Math.min(lastValidDonation, maximumDeduction);
  const taxBenefit = effectiveDonation * 0.26;
  const t3 = styles;
  const t4 = styles;
  const t5 = !isMobile && <DKGavebrevTaxBarChart maximumDeduction={maximumDeduction} donation={lastValidDonation} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
  let t6;
  if ($[6] !== t5) {
    t6 = <div className={styles.desktopChart}>{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = styles;
  let t8;
  if ($[8] !== title) {
    t8 = <h5>{title}</h5>;
    $[8] = title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== description) {
    t9 = <p>{description}</p>;
    $[10] = description;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = isMobile && <HorizontalDKGavebrevTaxBarChart maximumDeduction={maximumDeduction} donation={lastValidDonation} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
  let t11;
  if ($[12] !== t10) {
    t11 = <div className={styles.mobileChart}>{t10}</div>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = incomeLabel ?? "Indkomst f\xF8r skat";
  let t13;
  if ($[14] !== t12) {
    t13 = <label htmlFor="income-input">{t12}:</label>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== locale) {
    t14 = val => {
      setIncome(formatAmountInput(val, locale));
    };
    $[16] = locale;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== income || $[19] !== t14) {
    t15 = <EffektTextInput value={income} name="income-input" type="tel" placeholder="0" onChange={t14} denomination="kr" variant="underlined" />;
    $[18] = income;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t13 || $[22] !== t15) {
    t16 = <div className={styles.input}>{t13}{t15}</div>;
    $[21] = t13;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = suggestedPercentages.map(percentage => {
    const suggestedAmount = Math.round(lastValidIncome * percentage);
    const isSelected = lastValidDonation === suggestedAmount && suggestedAmount > 0;
    return <EffektButton key={percentage} onClick={() => {
      plausible("GavebrevTaxWidgetSelectPercentage", {
        props: {
          page: window.location.pathname,
          percentage: percentage * 100,
          amount: suggestedAmount
        }
      });
      setDonation(thousandize(suggestedAmount, locale));
    }} variant={EffektButtonVariant.SECONDARY} selected={isSelected} style={{
      fontSize: "0.9rem"
    }} squared={true}>{(percentage * 100).toFixed(0)}%</EffektButton>;
  });
  let t18;
  if ($[24] !== t17) {
    t18 = <div className={styles.suggestedPercentages}>{t17}</div>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  const t19 = donationLabel ?? "Donation";
  let t20;
  if ($[26] !== t19) {
    t20 = <label htmlFor="donation-input">{t19}:</label>;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== locale) {
    t21 = val_0 => {
      setDonation(formatAmountInput(val_0, locale));
    };
    $[28] = locale;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== donation || $[31] !== t21) {
    t22 = <EffektTextInput value={donation} name="donation-input" type="tel" placeholder="0" onChange={t21} denomination="kr" variant="underlined" />;
    $[30] = donation;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t20 || $[34] !== t22) {
    t23 = <div className={styles.input}>{t20}{t22}</div>;
    $[33] = t20;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t16 || $[37] !== t18 || $[38] !== t23) {
    t24 = <div className={styles.inputs}>{t16}{t18}{t23}</div>;
    $[36] = t16;
    $[37] = t18;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  const t25 = resultDescriptionTemplate && maximumDeduction > 0 && <p>{resultDescriptionTemplate.replace("{income}", thousandize(lastValidIncome, locale)).replace("{maxDeduction}", thousandize(maximumDeduction, locale)).replace("{donation}", thousandize(lastValidDonation, locale)).replace("{taxBenefit}", thousandize(taxBenefit, locale))}</p>;
  let t26;
  if ($[40] !== buttonText || $[41] !== lastValidDonation || $[42] !== plausible || $[43] !== setWidgetContext || $[44] !== widgetContext) {
    t26 = buttonText && <div className={styles.cta}><EffektButton onClick={() => {
        plausible("OpenDonationWidget", {
          props: {
            page: window.location.pathname
          }
        });
        plausible("OpenDonationWidgetGavebrevTaxWidgetCTA", {
          props: {
            page: window.location.pathname,
            donation: lastValidDonation
          }
        });
        setWidgetContext({
          ...widgetContext,
          open: true,
          prefilledSum: lastValidDonation,
          prefilledRecurring: null
        });
      }} variant={EffektButtonVariant.PRIMARY} style={{
        padding: "0.75rem 3rem"
      }}>{buttonText}</EffektButton></div>;
    $[40] = buttonText;
    $[41] = lastValidDonation;
    $[42] = plausible;
    $[43] = setWidgetContext;
    $[44] = widgetContext;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t11 || $[47] !== t24 || $[48] !== t25 || $[49] !== t26 || $[50] !== t7.description || $[51] !== t8 || $[52] !== t9) {
    t27 = <div className={t7.description}>{t8}{t9}{t11}{t24}{t25}{t26}</div>;
    $[46] = t11;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
    $[50] = t7.description;
    $[51] = t8;
    $[52] = t9;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t27 || $[55] !== t4.container || $[56] !== t6) {
    t28 = <div className={t4.container}>{t6}{t27}</div>;
    $[54] = t27;
    $[55] = t4.container;
    $[56] = t6;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t28 || $[59] !== t3.wrapper) {
    t29 = <div className={t3.wrapper}>{t28}</div>;
    $[58] = t28;
    $[59] = t3.wrapper;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  return t29;
};

/** The amount typed into an input, ignoring the thousand separators. An empty input is 0. */
const parseAmountInput = (value: string): number => Number(value.replace(/\D/g, ""));

/** Formats what the user typed with thousand separators, keeping an empty input empty. */
const formatAmountInput = (value: string, locale: string): string => value === "" ? "" : thousandize(parseAmountInput(value), locale);